import { type ComponentType, createContext, type ReactNode } from "react";

export type HeaderAuthProps = { signedOut: ReactNode };

/**
 * The component that shows the visitor's sign-in state in the Apex 25 header. The app sets it
 * (main.tsx, inside ClerkProvider). tryapex25.com has no Clerk and must not load it, so there it
 * stays unset and the header just offers "Log in / Sign up".
 */
export const HeaderAuthSlot = createContext<ComponentType<HeaderAuthProps> | null>(null);
